export const getAnswers = (payload?: any) => ({
  type: "@saga/GET_ANSWERS",
  payload,
});
